module.exports = __webpack_public_path__ + "img/recruit-icon-3.7212feba.png";